import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const MapBase = (
  <path
    fill='currentColor'
    d='M3 5.878c0-.372.298-.746.668-.836L7.87 4.02c.37-.09.668.134.668.511v12.244c0 .372-.297.746-.668.836l-4.202 1.022C3.3 18.723 3 18.5 3 18.122V5.878zm6.23-1.347c0-.372.283-.536.615-.375l4.31 2.097c.34.165.614.595.614.972V19.47c0 .372-.282.536-.614.375l-4.31-2.097c-.34-.165-.614-.595-.614-.972V4.53zm6.232 2.694c0-.372.297-.746.668-.836l4.202-1.022c.369-.09.668.134.668.511v12.244c0 .372-.298.746-.668.836L16.13 19.98c-.37.09-.668-.134-.668-.511V7.225z'
  />
)

export const Map = createIcon({
  displayName: 'Map',
  viewBox: '0 0 24 24',
  path: MapBase,
})

export const MapOffBase = (
  <g fill='currentColor' fillRule='evenodd' clipRule='evenodd'>
    <path d='M13.974 12.24c.017-.052.026-.105.026-.159V3.919c0-.252-.2-.401-.445-.341l-2.802.681c-.247.06-.445.31-.445.558v3.757l3.666 3.666zm-3.666-1.78v2.519c0 .252.2.4.445.341l1.942-.472-2.387-2.388zm-.462-2.347V4.817c0-.252-.183-.539-.41-.649L6.564 2.77c-.221-.107-.41.003-.41.25v1.4l3.693 3.693zM6.154 6.306l3.692 3.692v2.981c0 .248-.188.358-.41.25l-2.873-1.398c-.226-.11-.41-.396-.41-.648V6.306zm-.462-2.347V3.02c0-.252-.2-.401-.445-.341l-.67.163 1.115 1.116zM3.06 3.212l2.632 2.632v5.339c0 .248-.198.498-.445.558l-2.802.681c-.246.06-.445-.09-.445-.341V3.919c0-.248.199-.498.445-.558l.615-.15z' />
    <path d='M12.646 14.647L1.333 3.333l.942-.942L13.59 13.704l-.943.943z' />
  </g>
)

export const MapOff = createIcon({
  displayName: 'MapOff',
  viewBox: '0 0 16 16',
  path: MapOffBase,
})
